
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import getArticleSources from '@root/modules/article/utils/getArticleSources';

interface Props {
  article: ArticleData;
  easyRead: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    article: {
      type: Object,
      required: true,
    },
    easyRead: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    sources() {
      return getArticleSources(this.article);
    },
  },
});
